import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { Scan, ScanObject } from 'src/app/interfaces/scan.interfaces';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

interface TableRow {
  id: number;
  x: number;
  y: number;
  image: string;
  name: string;
  ncc: string;
  objectClass: string;
  huell: string;
  shields: string;
  player: { id: number; name: string };
  updatedBy: { id: number; name: string };
  updatedAt: Date;
  createdBy: { id: number; name: string };
  createdAt: Date;
}

@Component({
  standalone: false,
  selector: 'app-scan-detail',
  templateUrl: './scan-detail.component.html',
})
export class ScanDetailComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  private id: number = -1;
  scan: Scan | undefined;
  tableRows: TableRow[] = [];
  isLoaded = false;
  error: any = null;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.subscription = this.route.paramMap.subscribe((params) => {
      this.id = Number.parseInt(params.get('id') || '-1');
      this.loadScan();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  async loadScan() {
    if (this.id < 0) return;
    try {
      this.scan = await this.apiService.fetchScan(this.id);
      this.buildTableRows();
      this.isLoaded = true;
    } catch (error) {
      handleApiError(this.authService, this.router, error);
      this.error = error;
    }
  }

  private buildTableRows() {
    if (!this.scan) return;

    const colonies = this.scan.scanObjects
      .filter((obj) => obj.objectClass === 'Kolonie')
      .map((colony) => ({
        id: colony.id,
        x: colony.x,
        y: colony.y,
        image: `${environment.imageUrl}/planets/${colony.image}.gif`,
        name: colony.name,
        ncc: '-',
        objectClass: colony.objectClass,
        huell: '-',
        shields: '-',
        player: colony.owner,
        updatedBy: colony.updatedBy,
        updatedAt: colony.updatedAt,
        createdBy: colony.createdBy,
        createdAt: colony.createdAt,
      }));

    const ships = this.scan.scanObjects
      .filter((obj) => obj.objectClass !== 'Kolonie')
      .map((ship) => ({
        id: ship.id,
        x: ship.x,
        y: ship.y,
        image: `${environment.imageUrl}/ships/${ship.image}.gif`,
        name: ship.name,
        ncc: ship.ncc,
        objectClass: ship.objectClass,
        huell: ship.shieldsActive ? '-' : `${ship.huell}/${ship.huellMax}`,
        shields: ship.shieldsActive ? `${ship.shields}/${ship.shieldsMax}` : '-',
        player: ship.owner,
        updatedBy: ship.updatedBy,
        updatedAt: ship.updatedAt,
        createdBy: ship.createdBy,
        createdAt: ship.createdAt,
      }));

    this.tableRows = [...colonies, ...ships];
  }
}
